<template>
  <v-container
    fluid
    :grid-list-lg="$vuetify.breakpoint.smAndDown"
    :grid-list-xxl="!$vuetify.breakpoint.smAndDown"
    text-xs-center
    pa-0
  >
    <v-layout
      row
      wrap
    >
      <v-flex
        xs6
        sm6
        md3
        :py-3="isMobile"
        v-for="item in categories"
        :key="item.title"
      >
        <image-card-redesigned
          :src="item.image"
          :title="$t(item.title)"
          :to="{
                  path: item.slug,
                  query: { techs: item.techniques.join(',') },
                }"
          :count="item.count"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from 'vue'
import ImageCardRedesigned from '../../../views/Home/ImageCardRedesigned.vue'

export default Vue.extend({
  name: 'Categories',
  components: { ImageCardRedesigned },
  props: {
    categories: {
      type: Array,
      required: true
    }
  },
})
</script>


<style
  scoped
  lang="scss"
>

</style>